<template>
  <div class="box">
    <!-- 标题和搜索盒子 -->
    <div class="headlogo">
      <!-- 左侧盒子 -->
      <div class="head-left">
        <!-- logo -->
          <div class="msoimg">
            <img src="../assets/imgs/clurlogo.png" alt="">
          </div>
          <!-- logo标题 -->
          <div class="mso-title">
            <div class="text1">
              江苏海宏智能科技有限公司
            </div>
            <div class="text2">
              -JIANGSU OCEAN&MACRO INTELLIGENT TECHNOLOGY Co., Ltd.-
            </div>
          </div>
      </div>
      <!-- 右侧盒子 -->
      <div class="head-rgiht">
        <!-- 微信公众号 -->
        <div class="weChat-official-account">
          <img src="../assets/imgs/微信.png" alt="">
          <el-button type="text" class="but-left">微信公众号</el-button>
          <p class="horizontal-line"></p>
          <el-button type="text" class="but-right">收藏本站</el-button>
          <!-- 二维码 -->
          <div class="QR-code">
            <img src="../assets/imgs/公众号 拷贝.png" alt="">
          </div>
        </div>
        <!-- 右侧搜索输入框和按钮 -->
        <div class="head-inp">
          <el-input type="text" placeholder="输入关键词搜索" v-model="search"></el-input>
          <el-button class="head-but" @click="searchbtn">搜索</el-button>
        </div>
      </div>
    </div>
    <!-- 导航栏盒子 -->
    <el-breadcrumb class="Navigation">
        <el-breadcrumb-item class="a-link" :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item class="a-link" :to="{ path: './AboutUs' }"><a>关于我们</a></el-breadcrumb-item>
        <el-breadcrumb-item class="a-link" :to="{ path: '/ProductCenter' }"><a>产品中心</a></el-breadcrumb-item>
        <el-breadcrumb-item class="a-link" :to="{ path: '/CaseSharing' }"><a>案例分享</a></el-breadcrumb-item>
        <el-breadcrumb-item class="a-link" :to="{ path: '/TalentRecruitment' }"><a>人才招聘</a></el-breadcrumb-item>
        <el-breadcrumb-item class="a-link" :to="{ path: '/Businesscooperation' }"><a>商务合作</a></el-breadcrumb-item>
        <el-breadcrumb-item class="a-link" :to="{ path: '/Notice' }"><a>公告</a></el-breadcrumb-item>
        <!-- <el-breadcrumb-item class="a-link" :to="{ path: '/Bidding' }"><a>招投标公告栏</a></el-breadcrumb-item> -->
        <!-- <el-breadcrumb-item class="a-link" :to="{ path: '/News' }"><a>企业新闻</a></el-breadcrumb-item> -->
        <el-breadcrumb-item></el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 您的位置 -->
    <div class="location">
      <!-- 上半部分标题 -->
      <div class="location-top">
        <p>您的位置:</p>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>关于我们</el-breadcrumb-item>
          <el-breadcrumb-item>{{this.activeName}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- 下半部分tabs标签页 -->
      <div class="location-bottom">
        <template>
          <el-tabs v-model="activeName">
            <el-tab-pane label="招标公告" name="招标公告">
              <inviteTenders></inviteTenders>
            </el-tab-pane>
            <el-tab-pane label="中标公告" name="中标公告">
              <selected></selected>
            </el-tab-pane>
            <!-- <el-tab-pane label="公示" name="公示">
              <publicity></publicity>
            </el-tab-pane> -->
          </el-tabs>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import inviteTenders from '../Notice/InviteTenders'
import selected from '../Notice/Selected'
import publicity from '../Notice/publicity'
export default {
  // 公告
  name: 'Notice',
  data() {
    return {
      activeName: '招标公告',
      search: ''
    }
  },
  methods: {
    searchbtn() {
      console.log(this.search)
    }
  },
  components: {
    inviteTenders,
    selected,
    publicity
  }
}
</script>

<style scoped>

.location{
  width: 100%;
  height: 100%;
  margin-top: 3.9375rem;
  /* padding-left: 8.125rem; */
}

.location-top{
  width: 100%;
  height: 100%;
  display: flex;
  padding-bottom: 3.75rem;
  line-height: 1.5625rem;
  font-size: 1.625rem;
}

.location-top .el-breadcrumb, /deep/ .location .el-breadcrumb__inner, /deep/ .el-breadcrumb__separator{
  font-size: 1.625rem;
  color: #000;
}

/deep/ .location-top .el-breadcrumb__item:last-child .el-breadcrumb__inner{
  color: #000 !important;
}

.location-top p{
  width: 112px;
  margin-right: .625rem;
  padding-left: 8.125rem;
}

.location-bottom{
  width: 120rem;
  height: 100%;
}

/deep/ .el-tabs__nav-scroll{
  width: 100%;
  height: 3.75rem;
  padding-left: 8.125rem;
}

/deep/ .el-tabs__nav-wrap::after{
  position: absolute;
  left: 8.125rem;
}

/deep/ .location-bottom .el-tabs__item{
  font-size: 1.875rem;
  padding-right: 6.875rem;
}

/deep/ .el-tabs__active-bar{
  position: absolute;
  bottom: -1.25rem;
  border-bottom: .3125rem solid #409EFF;
}

/deep/.location-top .el-breadcrumb__inner.is-link{
  font-weight: 400 !important;
}

/deep/.location-top .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover{
  color: #000;
}
</style>
